import script from "./carousel-with-controller.vue?vue&type=script&lang=ts&setup=true"
export * from "./carousel-with-controller.vue?vue&type=script&lang=ts&setup=true"

import "./carousel-with-controller.vue?vue&type=style&index=0&id=3d3dda67&lang=scss"

const __exports__ = script;

export default __exports__